<div class="page-header-container">
    <div class="tabs-wrapper d-flex flex-grow-1">
        <ul class="nav nav-tabs border-0">
            <li class="nav-item cursor-pointer">
                <a class="nav-link fw-semibold active">{{"assetFleetManagement.tabs.assets"| translate}}</a>
            </li>
             <li class="nav-item cursor-pointer">
                <a class="nav-link fw-semibold">{{"assetFleetManagement.tabs.services"| translate}}</a>
            </li>
            <li class="nav-item cursor-pointer">
                <a class="nav-link fw-semibold">{{"assetFleetManagement.tabs.expenses"| translate}}</a>
            </li>
            <li class="nav-item cursor-pointer">
                <a class="nav-link fw-semibold">{{"assetFleetManagement.tabs.activePartner"| translate}}</a>
            </li>
        </ul>
    </div>
</div>

<div class="header-buttons-box">
    <div class="custom-text-input-container search-container flex-grow-1">
        <i class="app-icon icon icon-search icon-xl"></i>
        <div class="custom-text-input-wrap">
            <kendo-textbox
                #assetSearch
                type="text"
                [clearButton]='true'
                placeholder="{{'assetFleetManagement.searchPlaceHolder' | translate }}"
                [(ngModel)]="pageFilter.searchText"
                (valueChange)="searchQuery$.next($event)">
            </kendo-textbox>
        </div>
    </div>

    <button *ngIf="activeFilterCount <= 0" class="btn white-btn text-uppercase">
        {{'assetFleetManagement.filters' | translate}}
    </button>

    <div class="buttons-group-box table-view-mode-switch d-none d-lg-flex">
        <div class="btn-group" role="group">
            <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.LIST_VIEW)" 
                [disabled]="tableViewMode === TABLE_VIEW_MODES.LIST_VIEW">
                <i class="app-icon icon icon-view-list icon-lg me-2"></i>
                <span>{{'common.listView' | translate }}</span>
            </button>
            <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.CARDS_VIEW)" 
                [disabled]="tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW">
                <i class="app-icon icon icon-view-grid icon-lg me-2"></i>
                <span>{{'common.cardsView' | translate }}</span>
            </button>
        </div>
    </div>
</div>

<div class="d-flex flex-column align-items-center my-5 my-lg-0" *ngIf="!hasData">
    <no-records-placeholder
        [showNoRecordsHeader]="true"
        [isActiveFilter]="activeFilterCount > 0"
        (clickHereEvent)="resetFiltersHandler()"
    ></no-records-placeholder>
</div>

<assets-fllet-management-view
    [assets]="assets"
    [navigateToDetailHandler]="navigateToDetailHandler"
    [props]="props">
</assets-fllet-management-view>


<button *ngIf="showBackToTop" type="button" class="btn btn-scroll-to-top" (click)="scrollToTop()">
    <i class="app-icon icon icon-back-to-top icon-xl"></i>
</button>
